@if (product) {
    <aimo-product-tag [product]="product"/>
    <div
        (mouseleave)="hideAddToCart()"
        class="aimo-product-grid-item"
        id="product_{{ product.code }}"
        [ngClass]="{ 'lowest-comparison-price': product.lowestPriceInComparison }">
        <div class="cx-actions">
            <div class="cx-actions-wrapper">
                @if (!isComparisonProduct) {
                    @if (product.crossSellingProducts && showCrossSelling) {
                        <button
                            #popOver="ngbPopover"
                            [attr.aria-label]="'aimo.product.crossSelling' | cxTranslate"
                            class="btn btn-primary btn-icon btn-icon-light btn-sm d-inline-flex"
                            placement="bottom"
                            container="body"
                            [ngbPopover]="crossSellingProducts"
                            [autoClose]="'outside'"
                            popoverClass="popover-cross-selling">
                            @if (crossSellingComponent$ | async; as crossSellingComponent) {
                                <i
                                    class="aimo-icon icon-sm icon-diamonds-four"
                                    placement="top"
                                    container="body"
                                    triggers="mouseenter:mouseleave"
                                    popoverClass="popover-default"
                                    ngbPopover="{{ crossSellingComponent.title }}"></i>
                            }
                        </button>
                    }
                    @if (showComparison) {
                        <button
                            [attr.aria-label]="'productList.comparison.tooltip' | cxTranslate"
                            [title]="'productList.comparison.tooltip' | cxTranslate"
                            (click)="addToComparison(product)"
                            class="btn btn-primary btn-icon btn-icon-light btn-sm"
                            placement="top"
                            container="body"
                            ngbPopover="{{ 'productList.comparison.tooltip' | cxTranslate }}"
                            triggers="mouseenter:mouseleave"
                            popoverClass="popover-default">
                            <i class="aimo-icon icon-sm icon-arrow-left-right"></i>
                        </button>
                    }
                    @if (user$ | async; as user) {
                        @if (!isPikatukku() &&
                        (loggedUser$ | async) &&
                        (user.customerAdmin || !user.isHideNormalOrderTemplatesFromBasicUsers)) {
                            <button
                                [id]="'product_add_to_template_' + idSuffix"
                                (click)="addToOrderTemplate('product_add_to_template_' + idSuffix)"
                                [attr.aria-label]="'productList.orderTemplate.tooltip' | cxTranslate"
                                [title]="'productList.orderTemplate.tooltip' | cxTranslate"
                                class="btn btn-primary btn-icon btn-icon-light btn-sm d-inline-flex"
                                placement="top"
                                container="body"
                                ngbPopover="{{ 'productList.orderTemplate.tooltip' | cxTranslate }}"
                                triggers="mouseenter:mouseleave"
                                popoverClass="popover-default">
                                <i class="aimo-icon icon-sm icon-file-plus"></i>
                            </button>
                        }
                    }
                    @if (loggedUser$ | async) {
                        <button
                            [attr.aria-label]="
                                (product.favorite ? 'aimo.favorite.remove' : 'aimo.favorite.add') | cxTranslate
                            "
                            class="btn btn-primary btn-icon btn-icon-light btn-sm d-inline-flex"
                            placement="top"
                            [ngbPopover]="
                                (product.favorite ? 'aimo.favorite.remove' : 'aimo.favorite.add') | cxTranslate
                            "
                            container="body"
                            triggers="mouseenter:mouseleave"
                            popoverClass="popover-default popover-hide-mobile"
                            (click)="toggleFavorite()">
                            <i
                                class="aimo-icon icon-sm icon-star"
                                [ngClass]="{
                                    'icon-star-filled': product.favorite,
                                    'icon-star': !product.favorite,
                                }"></i>
                        </button>
                    }
                }
                @if (isComparisonProduct) {
                    <button
                        [attr.aria-label]="'aimo.product.comparison.remove' | cxTranslate"
                        [title]="'aimo.product.comparison.remove' | cxTranslate"
                        class="btn btn-primary btn-icon btn-icon-light btn-sm d-inline-flex"
                        (click)="removeFromComparisonList(product.code)">
                        <i class="aimo-icon icon-sm icon-x"></i>
                    </button>
                }
            </div>
        </div>
        @if (product.solrDebugInfo) {
            <div [innerHTML]="product.solrDebugInfo | safeHtml"></div>
        }
        <div class="cx-product-image-container">
            <!-- href is for google bots to follow links -->
            <a tabindex="-1" role="button" [href]="product.url" (click)="doNotOpen($event)">
                <cx-media
                    [id]="'product_image_' + idSuffix"
                    (click)="openProductModal($event, 'product_image_' + idSuffix)"
                    class="cx-product-image"
                    [container]="product.images?.PRIMARY"
                    format="product"
                    [loading]="'lazy'"
                    [title]="product.name"
                    [alt]="product.name"></cx-media>
            </a>
        </div>
        <div class="product-name-wrapper">
            <button
                [id]="'product_name_' + idSuffix"
                class="btn-link text-left"
                (click)="openProductModal($event, 'product_name_' + idSuffix)">
                <span
                    class="cx-product-name"
                    [attr.aria-label]="
                        'aimo.product.openModal.arialLabel' | cxTranslate: { productName: product.nameHtml }
                    "
                    [innerHTML]="product.nameHtml">
                </span>
            </button>
            <div class="product-code text-dark-grey">
                <aimo-product-code [product]="product"></aimo-product-code>
                <div class="d-inline aimo-popover ml-2">
                    <aimo-last-purchased [product]="product"></aimo-last-purchased>
                </div>
            </div>
        </div>
        @if (loggedUser$ | async) {
            <div class="price">
                <div class="active-price">
                    @if (product.price) {
                        @if (product.myAssortment) {
                            @if (myAssortmentLabelSuffix$ | async; as myAssortmentLabelSuffix) {
                                <i
                                    placement="top"
                                    container="body"
                                    triggers="mouseenter:mouseleave"
                                    [ngbPopover]="
                                        'aimo.product.myAssortment' + myAssortmentLabelSuffix.suffix | cxTranslate
                                    "
                                    class="aimo-icon icon-inline icon-smd icon-house-line-bold"
                                    [ngClass]="product.strikeThroughPrice ? 'icon-red' : 'icon-petrol-blue'"></i>
                            }
                        }
                        <span
                            [attr.aria-label]="'aimo.product.price.arialLabel' | cxTranslate"
                            class="align-baseline"
                            [ngClass]="
                                product.strikeThroughPrice
                                    ? 'promo-price'
                                    : product.myAssortment
                                      ? 'my-assortment-price'
                                      : ''
                            ">
                            <span class="price-value">{{ product.price?.formattedValue }}</span>
                            <span class="d-none d-md-inline"> / {{ product.unit?.name }}</span>
                        </span>
                        @if (product.strikeThroughPrice) {
                            <span
                                class="text-strike align-baseline ml-2"
                                [attr.aria-label]="'aimo.product.strikePrice.arialLabel' | cxTranslate">
                                {{ product.strikeThroughPrice.formattedValue }}
                            </span>
                        }
                        @if (product.taxPercentage > 0) {
                            <span class="text-dark-grey ml-1"
                            >{{ 'aimo.product.vat' | cxTranslate: {amount: product.taxPercentage} }}
                            </span>
                        }
                    }
                </div>
                <div class="row position-relative add-to-cart-row">
                    @if (product.price) {
                        <div
                            class="col-auto mr-auto comparison-price"
                            [ngClass]="{
                                hidden: (isStepperVisible$ | async),
                                'mobile-max-width':
                                    (isPikatukku() && !product.pikatukkuWebShopProduct) ||
                                    (!isPikatukku() &&
                                        product.purchasable &&
                                        !(
                                            product.stock.stockLevelStatus === 'outOfStock' && product.similarProducts
                                        )) ||
                                    ((!isPikatukku() || !product.pikatukkuWebShopProduct) &&
                                        !product.purchasable &&
                                        product.stock.stockLevelStatus === 'outOfStock'),
                                'web-shop-product-max-width': product.pikatukkuWebShopProduct,
                            }">
                            <div class="text-dark-grey">
                                @if (product.comparisonPrice) {
                                    <span class="align-middle">
                                        <span class="d-inline-block mr-1">{{
                                                product.comparisonPrice.formattedValue
                                            }}</span>
                                        <span class="d-inline-block mr-1"> / {{ product.comparisonUnit?.name }}</span>
                                        @if (product.taxPercentageCatalogPrice === 0) {
                                            <span class="d-inline-block">{{
                                                    'aimo.product.vat' | cxTranslate: {amount: product.taxPercentage}
                                                }}</span>
                                        }
                                    </span>
                                }
                                @if (product.lowestPriceInComparison) {
                                    <span [ngClass]="{ 'lowest-comparison-price': product.lowestPriceInComparison }">
                                        <i class="aimo-icon icon-inline icon-summer-green icon-sm icon-arrow-down"></i>
                                        <span class="ml-0">{{
                                                'aimo.product.lowestPriceInComparison' | cxTranslate
                                            }}</span>
                                    </span>
                                }
                            </div>
                            <div class="text-dark-grey">
                                <span class="d-inline-block mr-1">{{ product.priceWithTax?.formattedValue }}</span>
                                <span class="d-inline-block mr-1"> / {{ product.unit?.name }}</span>
                                <span class="d-inline-block">{{
                                        'aimo.product.vat' | cxTranslate: {amount: product.taxPercentageCatalogPrice}
                                    }}</span>
                            </div>
                        </div>
                        <div
                            [ngClass]="[
                                (isStepperVisible$ | async) ? 'wide-add-to-cart' : '',
                                product.pikatukkuWebShopProduct ? 'col-auto web-shop-product-col' : 'cx-add-to-cart',
                            ]">
                            @let isMobileApp = isMobileApp$ | async;
                            @if (!isPikatukku() || !isMobileApp) {
                                <aimo-cx-add-to-cart
                                    class="d-inline float-right add-to-cart-sm noPrint"
                                    (showHideStepper)="showHideStepper($event)"
                                    [showQuantity]="showQuantity"
                                    [showAvailabilityNotification]="true"
                                    [product]="product"
                                    [gtmProductAttributes]="gtmProductAttributes"
                                    [isPLP]="true"
                                    [idSuffix]="idSuffix"
                                    [addToCartCallBack]="addToCartCallBack"
                                    [options]="{
                                    displayAddToCart: true,
                                    addToCartString: '',
                                    iconAddToCart: 'aimo-icon icon-white icon-shopping-cart-simple icon-sm',
                                }">
                                </aimo-cx-add-to-cart>
                            }
                            @if (product.pikatukkuWebShopProduct) {
                                <div class="web-shop-product d-inline-block float-right">
                                    {{ 'aimo.product.shopProduct' | cxTranslate }}
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        }
        <div class="product-stock">
            <div class="cx-stock">
                @if (!isPikatukku()) {
                    <aimo-product-availability [stock]="product.stock"></aimo-product-availability>
                }
                @if (isPikatukku()) {
                    @for (ptstock of product.pikatukkuStock; track ptstock.warehouse.code) {
                        <div class="cx-stock">
                            <aimo-product-availability
                                [suggestiveMode]="true"
                                [printStockName]="true"
                                [stock]="ptstock">
                            </aimo-product-availability>
                        </div>
                    }
                }
            </div>
            @if (product.stock.stockLevelStatus === 'outOfStock' && product.similarProducts) {
                <div class="d-inline float-right similar-products ml-2">
                    <button
                        [id]="'product_stock_' + idSuffix"
                        class="btn-link"
                        (click)="openProductModal($event, 'product_stock_' + idSuffix, 'similar-products-container')">
                        <span class="text-underline">{{ 'aimo.product.lookSimilarProductsShort' | cxTranslate }}</span>
                    </button>
                </div>
            }
            <div class="float-right">
                <aimo-closingtime
                    [closingTime]="product.stock.closingTime"
                    [closingTimeForTheFuture]="product.stock.closingTimeForTheFuture"></aimo-closingtime>
            </div>
        </div>
    </div>
}

<ng-template #crossSellingProducts>
    <div class="cross-selling-products carousel-container noPrint">
        @if (getCrossSellingProducts(product) | async; as crossSelling) {
            <div class="popover-title">
                <h3>{{ crossSelling.title }}</h3>
                <button class="btn-link close-button" [attr.aria-label]="'aimo.arialLabel.close.modal' | cxTranslate">
                    <i class="aimo-icon icon-inline icon-x" (click)="closePopup()"></i>
                </button>
            </div>
            <aimo-cx-carousel
                class="carousel-products"
                role="region"
                tabindex="-1"
                itemWidth="10px"
                [hideIndicators]="true"
                [items]="crossSelling.carouselProducts"
                [template]="carouselItem"
                [idSuffix]="'crossSelling_product'">
            </aimo-cx-carousel>
        }
    </div>
    <ng-template #carouselItem let-item="item" let-index="index" let-idSuffix="idSuffix" let-gtmListId="gtmListId">
        <aimo-product-grid-item
            [product]="item"
            [showComparison]="false"
            [showCrossSelling]="false"
            [idSuffix]="idSuffix + '_' + index"
            [gtmProductAttributes]="item.gtmProductAttributes"
            [openProductPageFromLink]="false"
            [parentPopup]="crossSellingProductsPopup">
        </aimo-product-grid-item>
    </ng-template>
</ng-template>
